//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { ToastService, ToastType } from '@instaclause-webapp/shared-ui';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap as _observableMergeMap } from 'rxjs/operators';

// rxjs' `of` is overloaded on a rest parameter, so `of<Foo[]>(x)` resolves T to Foo and yields
// an Observable<Foo>. NSwag emits exactly that shape for every array-returning operation, which
// does not compile. This wrapper takes a single value, so the explicit type argument means what
// it reads as.
const _observableOf = <T>(value: T): Observable<T> => of(value);

interface RequestOptions {
  handleError: Boolean;
}

export const integrationsBaseUrl = new InjectionToken<string>('integrationsBaseUrl');

@Injectable()
export class IntegrationsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(integrationsBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://integrations.dev.instaclause.com/api';
  }

  /**
   * Updates the contact cache for a specific customer, synchronously.
   * @return OK
   */
  createUpdate(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/update';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves a summary of contacts for a specific customer.
   * @return OK
   */
  getSummary(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<ExternalContactSummary[]> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/summary';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSummary(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSummary(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<ExternalContactSummary[]>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<
              ExternalContactSummary[]
            >;
          }
        })
      );
  }

  protected processGetSummary(response: HttpResponseBase): Observable<ExternalContactSummary[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ExternalContactSummary[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ExternalContactSummary[]>(null as any);
  }

  /**
   * Adds or updates the general configuration for the specified provider.
   * @param body (optional)
   * @return OK
   */
  createConfig(
    provider: ContactOriginOptions,

    body?: any | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/config';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateConfig(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateConfig(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateConfig(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves the general configuration for the specified provider.
   * @return OK
   */
  getConfig(provider: ContactOriginOptions, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/config';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfig(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetConfig(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetConfig(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves the customer-specific configuration for the specified provider.
   * @return OK
   */
  getConfig_GET2(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/config';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetConfig_GET2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetConfig_GET2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetConfig_GET2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Adds or updates the customer-specific configuration for the specified provider.
   * @param body (optional)
   * @return OK
   */
  updateConfig(
    provider: ContactOriginOptions,

    customerId: number,

    body?: any | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/config';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateConfig(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateConfig(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateConfig(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Gets the integration status for a customer: cached record counts, whether a sync is
    pending or running, and how the last one ended.
     * @return OK
     */
  getStatus(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<IntegrationStatusDto> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/status';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetStatus(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetStatus(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<IntegrationStatusDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<IntegrationStatusDto>;
          }
        })
      );
  }

  protected processGetStatus(response: HttpResponseBase): Observable<IntegrationStatusDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IntegrationStatusDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IntegrationStatusDto>(null as any);
  }

  /**
   * Retrieves a fully resolved contact with provider-specific detail.
   * @return OK
   */
  getContactResolved(
    provider: ContactOriginOptions,

    customerId: number,

    externalId: string,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/contact/{externalId}/resolved';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (externalId === undefined || externalId === null)
      throw new Error("The parameter 'externalId' must be defined.");
    url_ = url_.replace('{externalId}', encodeURIComponent('' + externalId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContactResolved(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContactResolved(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetContactResolved(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Completes an OAuth authorization-code exchange for providers that authenticate that way.
    The frontend obtains the code from the provider's login popup and posts it here.
     * @param body (optional) 
     * @return OK
     */
  createConnect(
    provider: ContactOriginOptions,

    customerId: number,

    body?: any | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/connect';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateConnect(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateConnect(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateConnect(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Switches the integration off for a customer and discards its stored credentials.
   * @param provider The integration provider.
   * @param customerId The customer whose connection should be dropped.
   * @return No Content
   */
  createDisconnect(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/disconnect';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDisconnect(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDisconnect(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateDisconnect(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Queues the full synchronization pipeline for one customer and one provider: cache update,
    field mapping and relations. This is what the Refresh button on the integrations screen
    triggers.
     * @param provider The integration provider. Phases 2 and 3 are restricted to it.
     * @param customerId The customer to sync.
     * @return Accepted
     */
  createSync(
    provider: ContactOriginOptions,

    customerId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/integrations/{provider}/{customerId}/sync';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateSync(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateSync(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateSync(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 202) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ObservabilityClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(integrationsBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://integrations.dev.instaclause.com/api';
  }

  /**
     * Is anything wrong right now: the queue per provider, what is running, which worker
    instances are alive, how many integrations paused themselves, and the last scheduled batch.
    Succeeded / failed counts cover the last seven days.
     * @return OK
     */
  getSyncOverview(options?: RequestOptions): Observable<SyncOverviewDto> {
    let url_ = this.baseUrl + '/observability/sync/overview';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSyncOverview(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSyncOverview(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SyncOverviewDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SyncOverviewDto>;
          }
        })
      );
  }

  protected processGetSyncOverview(response: HttpResponseBase): Observable<SyncOverviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SyncOverviewDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SyncOverviewDto>(null as any);
  }

  /**
     * Which offices need attention: one row per configured integration with its last success,
    last failure, failure streak and paused state. Paused integrations come first.
     * @param paused (optional) Only integrations that are enabled but out of the nightly batch.
     * @param provider (optional) Only this provider.
     * @return OK
     */
  getSyncIntegrations(
    paused?: boolean | undefined,

    provider?: ContactOriginOptions | undefined,
    options?: RequestOptions
  ): Observable<IntegrationHealthDto[]> {
    let url_ = this.baseUrl + '/observability/sync/integrations?';
    if (paused === null) throw new Error("The parameter 'paused' cannot be null.");
    else if (paused !== undefined) url_ += 'paused=' + encodeURIComponent('' + paused) + '&';
    if (provider === null) throw new Error("The parameter 'provider' cannot be null.");
    else if (provider !== undefined) url_ += 'provider=' + encodeURIComponent('' + provider) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSyncIntegrations(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSyncIntegrations(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<IntegrationHealthDto[]>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<
              IntegrationHealthDto[]
            >;
          }
        })
      );
  }

  protected processGetSyncIntegrations(
    response: HttpResponseBase
  ): Observable<IntegrationHealthDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IntegrationHealthDto[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IntegrationHealthDto[]>(null as any);
  }

  /**
   * The queue and its history, newest first, with wait and run durations.
   * @param status (optional)
   * @param provider (optional)
   * @param customerId (optional)
   * @param from (optional)
   * @param to (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @return OK
   */
  getSyncRequests(
    status?: SyncRequestStatus | undefined,

    provider?: ContactOriginOptions | undefined,

    customerId?: number | undefined,

    from?: Date | undefined,

    to?: Date | undefined,

    page?: number | undefined,

    pageSize?: number | undefined,
    options?: RequestOptions
  ): Observable<SyncRequestListItemDtoPagedResult> {
    let url_ = this.baseUrl + '/observability/sync/requests?';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    if (provider === null) throw new Error("The parameter 'provider' cannot be null.");
    else if (provider !== undefined) url_ += 'provider=' + encodeURIComponent('' + provider) + '&';
    if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
    else if (customerId !== undefined)
      url_ += 'customerId=' + encodeURIComponent('' + customerId) + '&';
    if (from === null) throw new Error("The parameter 'from' cannot be null.");
    else if (from !== undefined)
      url_ += 'from=' + encodeURIComponent(from ? '' + from.toISOString() : '') + '&';
    if (to === null) throw new Error("The parameter 'to' cannot be null.");
    else if (to !== undefined)
      url_ += 'to=' + encodeURIComponent(to ? '' + to.toISOString() : '') + '&';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSyncRequests(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSyncRequests(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<SyncRequestListItemDtoPagedResult>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SyncRequestListItemDtoPagedResult>;
          }
        })
      );
  }

  protected processGetSyncRequests(
    response: HttpResponseBase
  ): Observable<SyncRequestListItemDtoPagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as SyncRequestListItemDtoPagedResult);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SyncRequestListItemDtoPagedResult>(null as any);
  }

  /**
   * One request as a timeline, with the integration log lines written during it.
   * @param id The request.
   * @return OK
   */
  getSyncRequests_GET2(id: number, options?: RequestOptions): Observable<SyncRequestDetailDto> {
    let url_ = this.baseUrl + '/observability/sync/requests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSyncRequests_GET2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSyncRequests_GET2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SyncRequestDetailDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SyncRequestDetailDto>;
          }
        })
      );
  }

  protected processGetSyncRequests_GET2(
    response: HttpResponseBase
  ): Observable<SyncRequestDetailDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SyncRequestDetailDto);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SyncRequestDetailDto>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SyncClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(integrationsBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://integrations.dev.instaclause.com/api';
  }

  /**
   * Queues a cache-only refresh for every enabled integration of every active customer.
   * @return Accepted
   */
  createUpdate(options?: RequestOptions): Observable<SyncEnqueueSummary> {
    let url_ = this.baseUrl + '/sync/update';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SyncEnqueueSummary>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SyncEnqueueSummary>;
          }
        })
      );
  }

  protected processCreateUpdate(response: HttpResponseBase): Observable<SyncEnqueueSummary> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 202) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result202: any = null;
          result202 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SyncEnqueueSummary);
          return _observableOf(result202);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SyncEnqueueSummary>(null as any);
  }

  /**
     * Queues the full synchronization pipeline for every enabled integration of every active
    customer.
     * @return Accepted
     */
  create(options?: RequestOptions): Observable<SyncEnqueueSummary> {
    let url_ = this.baseUrl + '/sync';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SyncEnqueueSummary>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SyncEnqueueSummary>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<SyncEnqueueSummary> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 202) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result202: any = null;
          result202 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SyncEnqueueSummary);
          return _observableOf(result202);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SyncEnqueueSummary>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

export enum ContactOriginOptions {
  Manual = 'Manual',
  AdminPulse = 'AdminPulse',
  FidManager = 'FidManager',
  AdminConsult = 'AdminConsult',
  Exact = 'Exact',
  Tess = 'Tess',
  Simplicate = 'Simplicate',
  HubSpot = 'HubSpot',
}

export interface ExternalContactSummary {
  externalId: string;
  displayName: string;
  updatedAt?: Date | undefined;
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
  errors?: { [key: string]: string[] };

  [key: string]: any;
}

export interface IntegrationHealthDto {
  customerId: number;
  customerName?: string | undefined;
  provider: ContactOriginOptions;
  enabled: boolean;
  autoSync: boolean;
  inProgress: boolean;
  lastSuccessAt?: Date | undefined;
  lastFailureCode?: string | undefined;
  lastFailureAt?: Date | undefined;
  consecutiveFailures: number;
  cachedRecordCount: number;
}

export enum IntegrationLogLevel {
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
}

export interface IntegrationStatusDto {
  recordCount: number;
  lastSync?: Date | undefined;
  companyCount?: number | undefined;
  enabled: boolean;
  syncInProgress: boolean;
  syncStartedAt?: Date | undefined;
  lastSyncError?: string | undefined;
  lastSyncErrorAt?: Date | undefined;
  autoSync: boolean;
}

export interface ProviderQueueStatsDto {
  provider: ContactOriginOptions;
  pending: number;
  running: number;
  succeededInWindow: number;
  failedInWindow: number;
  oldestPendingAgeSeconds?: number | undefined;
  staleRunning: number;
}

export interface RunningSyncDto {
  requestId: number;
  customerId: number;
  customerName?: string | undefined;
  provider: ContactOriginOptions;
  scope: SyncScope;
  claimedBy?: string | undefined;
  claimedAt?: Date | undefined;
  runningForSeconds: number;
  heartbeatAgeSeconds?: number | undefined;
  attempt: number;
}

export interface SyncEnqueueSummary {
  queued: number;
  skipped: number;
}

export interface SyncOverviewDto {
  generatedAt: Date;
  windowDays: number;
  providers: ProviderQueueStatsDto[];
  running: RunningSyncDto[];
  workers: SyncWorkerDto[];
  pausedIntegrations: number;
  lastScheduledEnqueueAt?: Date | undefined;
  lastScheduledEnqueueCount: number;
}

export interface SyncRequestDetailDto {
  request: SyncRequestListItemDto;
  notBefore?: Date | undefined;
  lastHeartbeatAt?: Date | undefined;
  timeline: SyncTimelineEventDto[];
  logs: SyncRequestLogDto[];
}

export interface SyncRequestListItemDto {
  id: number;
  customerId: number;
  customerName?: string | undefined;
  provider: ContactOriginOptions;
  scope: SyncScope;
  priority: number;
  status: SyncRequestStatus;
  attempt: number;
  requestedByUserId?: number | undefined;
  createdAt: Date;
  claimedAt?: Date | undefined;
  finishedAt?: Date | undefined;
  waitSeconds?: number | undefined;
  durationSeconds?: number | undefined;
  claimedBy?: string | undefined;
  errorCode?: string | undefined;
}

export interface SyncRequestListItemDtoPagedResult {
  items: SyncRequestListItemDto[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface SyncRequestLogDto {
  id: number;
  level: IntegrationLogLevel;
  message: string;
  data?: string | undefined;
  createdAt: Date;
}

export enum SyncRequestStatus {
  Pending = 'Pending',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

export enum SyncScope {
  Full = 'Full',
  CacheOnly = 'CacheOnly',
}

export interface SyncTimelineEventDto {
  at: Date;
  event: string;
  detail?: string | undefined;
}

export interface SyncWorkerDto {
  instance: string;
  lastHeartbeatAt?: Date | undefined;
  runningCount: number;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) {
    return throwError(() => result);
  }

  return throwError(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
